
export interface ColorOption {
  id: string;
  name: string;
  hex: string;
  imageUrl?: string; // Kumaş dokusu (Texture) resmi
  fabricType: string;
  priceModifier: number;
}

export interface SizeOption {
  id: string;
  label: string;
  width: number;
  length: number;
  priceModifier: number;
}

export interface VariantOption {
  id: string;
  label: string; // M, R, XL, XXL
  imageUrl?: string;
  imageUrlFront?: string;
  priceModifier: number;
}

export interface ComponentOption {
  id: string;
  name: string;
  imageUrl?: string; // Diagonal View (Angle 1)
  imageUrlFront?: string; // Front View (Angle 2)
  priceModifier: number;
  description?: string;
  variants?: VariantOption[]; // Başlık ölçüleri için (M, R, XL, XXL)
}

export interface CompanyInfo {
  logoUrl: string;
  companyName: string;
  authorizedPerson: string;
  address: string;
  phone: string;
  email: string;
  website: string;
}

export interface ProductConfig {
  id: string;
  name: string;
  basePrice: number;
  noneTopperImageUrl?: string; // Geen Topper seçeneği için resim (Açılı)
  noneTopperImageUrlFront?: string; // Geen Topper seçeneği için resim (Ön)
  sizes: SizeOption[];
  colors: ColorOption[];
  mattresses: ComponentOption[];
  bases: ComponentOption[];
  headboards: ComponentOption[];
  nightstands: ComponentOption[];
  toppers: ComponentOption[];
  voetbords: ComponentOption[];
  voets: ComponentOption[];
  poets: ComponentOption[];
}

export interface SelectedConfig {
  sizeId: string;
  colorId: string;
  mattressId: string;
  baseId: string;
  headboardId: string;
  headboardVariantId: string; // Seçilen başlık ölçüsü varyantı
  nightstandId: string;
  hasTopper: boolean;
  topperId: string;
  hasVoetbord: boolean;
  voetbordId: string;
  hasVoet: boolean;
  voetId: string;
  pootId: string;
}

export enum ViewMode {
  CUSTOMER = 'customer',
  ADMIN = 'admin'
}
